module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/mercadopago-logo.f9ae46a8.webp";